import { render } from "./SafetyTipsList.vue?vue&type=template&id=f8378c44"
import script from "./SafetyTipsList.vue?vue&type=script&lang=ts"
export * from "./SafetyTipsList.vue?vue&type=script&lang=ts"
script.render = render

export default script